module.exports = __webpack_public_path__ + "img/instructions2.55a4b42e.png";